import React, { useState, useEffect } from 'react';
import Tools from '../../Tools';
import Popover from '../../ui/Popover';


const DocsAIEP = (props) => {

    const [selectedAllDocs, setSelectedAllDocs] = useState(true);
    const [loading, setLoading] = useState({ client: false, campaign: false, tasks: false, documents: false, patent: false });
    const [error, setError] = useState(false);
    const [documentId, setDocumentId] = useState(null);

    const toggleAllDebts = () => {
        setSelectedAllDocs(!selectedAllDocs); //variable to toggle
        if (selectedAllDocs) {
            props.documents.forEach(d => { d.selected = false; });
            props.setDebtFn(0);
        } else {
            props.documents.forEach(d => { d.selected = true; });
            props.setDebtFn(props.documents.reduce((a, doc) => { return a + Number( props.documents.reduce((acc, obj) => acc + obj.monto_det, 0) >= 100000 && doc.descuento > 0 ? doc.gasto_cob + (doc.monto_det - (doc.monto_det * doc.descuento) / 100) : doc.monto_det + doc.gasto_cob)}, 0));
        }
    }

    const selectDebt = (event, doc) => {
        if (!event.target.checked) {
            doc.selected = false;
            props.setDebtFn(props.debt - Number(event.target.value));
        } else {
            doc.selected = true;
            props.setDebtFn(props.debt + Number(event.target.value));
        }
    }

    useEffect(() => {
        const totalDebt = props.documents.reduce((a, doc) => { return a + Number(props.documents.reduce((acc, obj) => acc + obj.monto_det, 0) >= 100000 && doc.descuento > 0 ? doc.gasto_cob + (doc.monto_det - (doc.monto_det * doc.descuento) / 100) : doc.monto_det + doc.gasto_cob) }, 0);
        props.setDebtFn(totalDebt);
    }, [props.documents]);

    return (
        <table className="fullWidth">
            <thead>
                <tr>
                    <th><input type="checkbox" onChange={toggleAllDebts} defaultChecked={true} /> &nbsp; Cedente</th>
                    <th className='center'>Operación</th>
                    <th className='right'>Estado</th>
                    <th className='right'>Vencimiento</th>
                    <th className='center'>Monto Total</th>
                    <th className='center'>M. Honorario</th>
                    <th className='center'>Tramo</th>
                    <th className='center'>Descto.</th>
                    <th className='right'>Saldo Total</th>
                </tr>
            </thead>
            <tbody>
                {props.documents.map((doc, index) => {
                    return (
                        <tr key={index}>
                            <td>
                                <label className="forCheckbox">
                                    <input type="checkbox" name={'ckeck' + index} value={props.documents.reduce((acc, obj) => acc + obj.monto_det, 0) >= 100000 && doc.descuento > 0 ? doc.gasto_cob + (doc.monto_det - (doc.monto_det * doc.descuento) / 100) : doc.monto_det + doc.gasto_cob} onChange={(e) => selectDebt(e, doc)} checked={doc.selected} defaultChecked={true} />
                                    AIEP 
                                </label>
                            </td>
                            <td className="center">{doc.num_documento}</td>
                            <td className="right">{doc.estado_inactivo}</td>
                            <td className="right">{doc.fecha_venc}</td>
                            <td className="center">{Tools.fmtClAmmount(doc.monto_det)}</td>
                            <td className="center">{Tools.fmtClAmmount(doc.gasto_cob)}</td>
                            <td className="right">{doc.tramo}</td>
                            <td className="right">{props.documents.reduce((acc, obj) => acc + obj.monto_det, 0) >= 100000?doc.descuento:0}%</td>
                            {props.documents.reduce((acc, obj) => acc + obj.monto_det, 0) >=100000 && doc.descuento > 0 ? (
                                <td className="right">{Tools.fmtClAmmount(doc.gasto_cob + (doc.monto_det - (doc.monto_det * doc.descuento) / 100)) }</td>
                            ):(
                                <td className="right">{Tools.fmtClAmmount(doc.monto_det + doc.gasto_cob)}</td>
                            )}
                        </tr>
                    );
                })}
            </tbody>
        </table>
    );

}

export default DocsAIEP;